/**
 * Created by trevor on 06/11/2016.
 *
 * functions to handle selection of items in a list.
 */

var selections = {};
function updateSelection(selectionName, id) {
    if (!selections.hasOwnProperty(selectionName)) {
        selections[selectionName] = [];
    }
    var sel = selections[selectionName];
    if (typeof(id) !== 'undefined' && id) {
        var cb = ge(selectionName + '-' + id);
        var index = selections[selectionName].indexOf(id);
        if (index === -1) {
            sel.push(id);
            cb.checked = true;
        }
        else {
            sel.splice(index, 1);
            cb.checked = false;
        }
    }
	if (sel.length){
		style(selectionName+'_selection_menu');
		ge(selectionName+'_selection_count').innerText = sel.length;
	} else {
		style(selectionName+'_selection_menu', 'move');
	}
	return sel;
}

function countSelection(name) {
	return selections[name].length;
}

function getSelection(selectionName) {
    return selections[selectionName];
}

function clearSelection(selectionName){
    if (typeof selectionName === 'undefined' || typeof selections[selectionName] === 'undefined') return;
    for (var i = 0, ii = selections[selectionName].length; i < ii; i++){
        ge(selectionName + '-' + selections[selectionName][i]).checked = false;
    }
    selections[selectionName] = [];
    updateSelection(selectionName);
}

function inSelection(selectionName, id){
    return (getSelection(selectionName).indexOf(id) >= 0);
}

class SelectionMgr {
	constructor(menu) {
		this._menu = menu || false;
		this._ids = [];
		this._items = [];
		this._menu = ge('selection_menu');
		this._count = ge('selection_count');

		this._setOf = null;

		onEv('selectionClearBtn', 'click', this.clear.bind(this));
	}

	get ids() {
		let ids = [];
		this._items.forEach(i => ids.push(i.id));
		return ids;
	}

	get empty() {
		return this._items.length == 0;
	}

	set setOf(inst) {
		this._setOf = inst;
	}

	recheck() {
		if (this._setOf == null) return;
		let i = 0;
		while(i < this._ids.length) {
			if (this._setOf.hasId(this._ids[i])){
				this._setOf.getById(this._ids[i]).checked = true;
				i++;
			}
			else {
				this._ids.splice(i, 1);
				this._items.splice(i, 1);
			}
		}
	}

	toggle(item) {
		if (!this.rem(item)) this.add(item);
		this.update();
	}
	
	add(item) {
		this._ids.push(item.id);
		this._items.push(item);
		item.checked = true;
	}
	
	rem(item) {
		let i = this._ids.indexOf(item.id);
		if (i === -1) return false;
		this._ids.splice(i,1);
		this._items.splice(i,1);
		item.checked = false;
		return true;
	}

	clear() {
		this._items.forEach(i => i.checked = false);
		this._ids = [];
		this._items = [];
		this.update();
	}

	update() {
		if (!this._menu) return;
		state(this._menu, this._items.length ? 'norm' : 'move');
		this._count.innerText = this._items.length;
	}

	hasId(id) {
		return this._ids.indexOf(id) !== -1;
	}
}